import { matchingEngineApi } from '../matching-engine.utils';
import { useQuery } from 'react-query';
import { useSession } from 'common/hooks';

export const useGetWorkItems = (filters: {
  profileId: string;
  skillIds?: string[];
  cutOffDays?: number;
}) => {
  const { account: user } = useSession();

  const getWorkItemsForSkill = () => {
    const params: { profileId: string; skillIds?: string[]; cutOffDays?: number } = filters;
    return matchingEngineApi.get(`work-items`, { params });
  };

  const queryKey = [
    'matching-engine',
    user?.organizationId,
    filters?.profileId,
    'work-items',
    filters?.skillIds ?? 'ALL_SKILLS',
    filters.cutOffDays,
  ];

  const queryResponse = useQuery(queryKey, getWorkItemsForSkill, {
    enabled: !!filters?.profileId,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  return {
    ...queryResponse,
    data: queryResponse.data?.data,
  };
};
